import { Stack, styled, Typography } from '@mui/material';

export const DocumentStyled = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  textDecoration: 'none',
  padding: theme.spacing(1),
  borderRadius: '4px',
  border: `1px solid ${theme.palette.secondary.main}`,
  backgroundColor: theme.palette.neutral.main,
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));

export const TitleStyled = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textWrap: 'nowrap',
});

export const SizeStyled = styled(Typography)(({ theme }) => ({
  fontSize: '0.625rem',
  lineHeight: '0.75rem',
  color: theme.palette.secondary[100],
}));
